import Button, { ButtonProps } from '@/components/Button/Button';
import CloseButton from '@/components/CloseButton/CloseButton';
import { DialogHTMLAttributes, FC, useEffect, useRef } from 'react';
import styles from './styles.module.scss';

export type ModalProps = {
  primaryBtnProps?: ButtonProps;
  secondaryBtnProps?: ButtonProps;
  title?: string;
} & DialogHTMLAttributes<HTMLDialogElement>;

export const Modal: FC<ModalProps> = ({
  primaryBtnProps,
  secondaryBtnProps,
  title,
  children,
  open = false,
  className,
  onClose,
  onCancel,
  ...props
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const closeModal = () => {
    if (dialogRef.current?.open) {
      dialogRef.current.close();
      document.body.style.overflow = '';
    }
  };

  const openModal = () => {
    if (dialogRef.current && !dialogRef.current.open) {
      dialogRef.current.showModal();
      document.body.style.overflow = 'hidden';
    }
  };

  useEffect(
    () => () => {
      document.body.style.overflow = '';
    },
    []
  );

  useEffect(() => {
    open ? openModal() : closeModal();
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      className={`${styles.modal} ${className}`}
      onCancel={
        onCancel
          ? onCancel
          : (e) => {
              e.preventDefault();
              onClose && closeModal();
            }
      }
      onClose={onClose}
      {...props}
    >
      {onClose && (
        <CloseButton onClick={closeModal} className={styles['close-button']} />
      )}

      {title && <h4 className={'bigger ' + styles['title']}>{title}</h4>}

      {children && <div className={styles['content']}>{children}</div>}

      <div className={styles['buttons']}>
        {secondaryBtnProps && (
          <Button variant="secondary" {...secondaryBtnProps} />
        )}

        {primaryBtnProps && <Button {...primaryBtnProps} />}
      </div>
    </dialog>
  );
};
